// Criar fatura manual (PO1-3307, épico PO1-3298): o embarcador monta a fatura da
// transportadora que não envia DOCCOB a partir dos documentos (CT-e ou NFse)
// ainda não faturados; ela entra na Auditoria de Faturas como qualquer outra.
import api from "./api";

export async function listarDocumentosDisponiveis(params = {}) {
  const { data } = await api.get("/faturas/manual/documentos-disponiveis", { params });
  return (data && data.itens) || [];
}

// 201 { id, numero, qtdDocumentos, valorTotal }; 409 { message } em número duplicado.
export async function criarFaturaManual(corpo) {
  const { data } = await api.post("/faturas/manual", corpo);
  return data;
}
